import { GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';

export const isSelectedDeletedRecords = (selectedRecords: Map<GridRowId, GridValidRowModel>) =>
    Object.values(Object.fromEntries(selectedRecords.entries())).some((record) => !record.enabled);
